
import React from 'react';
import { Icon } from './Icon';

const AboutUs: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-[#030712] relative overflow-hidden">
      {/* Decorative Blur */}
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-purple-600/10 rounded-full blur-[100px]"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:w-1/2">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 mb-6">
              <Icon name="Info" className="text-blue-400" size={16} />
              <span className="text-xs font-bold text-blue-400 uppercase tracking-widest">Tentang Kami</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-8 leading-tight">
              Teknologi <span className="gradient-text">Premium</span>, <br />
              Harga Tetap <span className="text-white">Minimum</span>.
            </h2>
            <div className="space-y-6 text-slate-400 text-lg leading-relaxed">
              <p>
                BisaBikin.id lahir dari misi untuk mendemokrasi teknologi digital. Kami percaya bahwa setiap bisnis, sekolah, dan individu berhak mendapatkan sistem berkualitas tinggi tanpa harus merogoh kocek terlalu dalam.
              </p>
              <p>
                Dengan memanfaatkan kekuatan <strong>Artificial Intelligence (AI)</strong> dan standar koding modern, kami mampu mempercepat proses produksi hingga 3x lipat. Hal ini membuat kami bisa menawarkan harga yang sangat kompetitif untuk pembuatan Website, Aplikasi Mobile, hingga sistem manajemen kompleks.
              </p>
            </div>
            
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-blue-500/10 rounded-xl">
                  <Icon name="Globe" className="text-blue-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-bold mb-1">Skalabilitas Global</h4>
                  <p className="text-sm text-slate-500">Sistem yang tumbuh bersama bisnis Anda.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="p-3 bg-purple-500/10 rounded-xl">
                  <Icon name="Users" className="text-purple-400" size={24} />
                </div>
                <div>
                  <h4 className="text-white font-bold mb-1">Berorientasi Pengguna</h4>
                  <p className="text-sm text-slate-500">Desain UI/UX yang intuitif dan mudah digunakan.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 relative">
            <div className="relative z-10 glass-morphism p-2 rounded-[2.5rem] border border-white/10 rotate-3 hover:rotate-0 transition-transform duration-700">
              <div className="rounded-[2rem] overflow-hidden aspect-square md:aspect-video lg:aspect-square">
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800" 
                  alt="Team Collaborating" 
                  className="w-full h-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-transparent to-transparent"></div>
              </div>
              
              {/* Floating Stat Card */}
              <div className="absolute -bottom-6 -left-6 glass-morphism p-6 rounded-2xl border border-white/20 shadow-2xl animate-bounce-slow">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center">
                    <Icon name="CheckCircle2" className="text-green-500" size={24} />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">100%</p>
                    <p className="text-xs text-slate-400 font-medium">Kepuasan Client</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
